import type { UIMessage } from 'ai';

const PLACEHOLDER_TEXT = '[photo — removed from history]';

/**
 * Returns a new messages array where every `file` part with an image
 * mediaType on any message EXCEPT the last one is replaced with a
 * lightweight text placeholder. The last message keeps its image intact.
 * Does not mutate the input.
 */
export function stripImagesFromHistory(messages: UIMessage[]): UIMessage[] {
  if (messages.length === 0) return messages;
  const lastIndex = messages.length - 1;

  return messages.map((msg, i) => {
    if (i === lastIndex) return msg;
    if (!msg.parts?.length) return msg;

    let mutated = false;
    const parts = msg.parts.map((part: any) => {
      if (part?.type === 'file' && typeof part?.mediaType === 'string' && part.mediaType.startsWith('image/')) {
        mutated = true;
        return { type: 'text', text: PLACEHOLDER_TEXT };
      }
      return part;
    });

    return mutated ? { ...msg, parts } : msg;
  });
}
